import * as Yup from "yup";
import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

export const courseInitialValues = {
  name: "",
  description: "",
  capacity: "",
  slot_place_id: 0,
  trainer: undefined,
  fee_ids: "",
  days: [],
  startDate: "",
  endDate: "",
  startTime: undefined,
  duration: undefined,
};

export const courseValidationSchema = Yup.object({
  name: Yup.string()
    .required(FIELD_REQUIRED_MESSAGE)
    .min(3, FIELD_REQUIRED_MESSAGE),
  capacity: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  slot_place_id: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  trainer: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  fee_ids: Yup.string(),
  days: Yup.array().min(1, FIELD_REQUIRED_MESSAGE),
  description: Yup.string()
    .required(FIELD_REQUIRED_MESSAGE)
    .min(3, FIELD_REQUIRED_MESSAGE),
  startTime: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  duration: Yup.number().required(FIELD_REQUIRED_MESSAGE),
});

export type CourseValues = typeof courseInitialValues;

export const createCourseFeeInitialValues = {
  name: "",
  description: "",
  registration_payment: 0,
  amount: 1,
  currency: "EUR",
  interval: "month",
  trial_period_days: 0,
  people: 1,
  discount: 0,
  repeat_discount: 0,
};

export const createCourseFeeValidationSchema = Yup.object({
  name: Yup.string()
    .required(FIELD_REQUIRED_MESSAGE)
    .min(3, FIELD_REQUIRED_MESSAGE),
  description: Yup.string()
    .required(FIELD_REQUIRED_MESSAGE)
    .min(3, FIELD_REQUIRED_MESSAGE),
  registration_payment: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  amount: Yup.number()
    .required(FIELD_REQUIRED_MESSAGE)
    .min(0, "Amount must be greater than or equal to 0"),
  currency: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  interval: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  trial_period_days: Yup.number()
    .min(0, "Trial period days must be greater than or equal to 0")
    .optional(),
  people: Yup.number()
    .required(FIELD_REQUIRED_MESSAGE)
    .min(1, "People must be at least 1"),
  discount: Yup.number()
    .min(0, "Discount must be greater than or equal to 0")
    .optional(),
  repeat_discount: Yup.number()
    .min(0, "Repeat discount must be greater than or equal to 0")
    .optional(),
});

export type CourseFeeValues = typeof createCourseFeeInitialValues;
